<template>
  <div :class="['store-grid container-fluid', className]">
    <div class="wrapper-fixed">
      <div class="row justify-content-end">
        <div class="col-12 col-lg-8 mb-3">
          <div :id="sectionID" class="section-name">Clients</div>
          <h2>Our Family of Industrial Stores </h2>
          <p>At FCG Ecommerce Solutions, we proudly work alongside a diverse group of specialized businesses that offer a wide selection of commercial and industrial products in the flow control and automation sectors. Each business in our network provides curated industrial solutions, with many products designed to work seamlessly together, ensuring you can find everything you need for your unique applications. Explore our trusted partners below to discover their extensive product offerings and expertise.</p>
        </div>
      </div>
      
      <ul class="row g-1 list-unstyled">
        <li class="col-12 col-sm-6 col-lg-4 store-card bg-color bg-color-soft">
            <a href="#" target="_blank" class="card store-card-wrapper">
                <div>
                    <img src="@/assets/images/logo-instrumart.gif" alt="TODO" />
                    <p class="sm-type">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque aliquet placerat.</p>
                </div>
                <div class="store-btn">Shop Now!</div>
            </a>
        </li>
        <li class="col-12 col-sm-6 col-lg-4 store-card bg-color bg-color-soft">
            <a href="#" target="_blank" class="card store-card-wrapper">
                <div>
                    <img src="@/assets/images/logo-instrumart.gif" alt="TODO" />
                    <p class="sm-type">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque aliquet placerat.</p>
                </div>
                <div class="store-btn">Shop Now!</div>
            </a>
        </li>
        <li class="col-12 col-sm-6 col-lg-4 store-card bg-color bg-color-soft">
            <a href="#" target="_blank" class="card store-card-wrapper">
                <div>
                    <img src="@/assets/images/logo-instrumart.gif" alt="TODO" />
                    <p class="sm-type">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque aliquet placerat.</p>
                </div>
                <div class="store-btn">Shop Now!</div>
            </a>
        </li>
        <li class="col-12 col-sm-6 col-lg-4 store-card bg-color bg-color-soft">
            <a href="#" target="_blank" class="card store-card-wrapper">
                <div>
                    <img src="@/assets/images/logo-instrumart.gif" alt="TODO" />
                    <p class="sm-type">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque aliquet placerat.</p>
                </div>
                <div class="store-btn">Shop Now!</div>
            </a>
        </li>
        <li class="col-12 col-sm-6 col-lg-4 store-card bg-color bg-color-soft">
            <a href="#" target="_blank" class="card store-card-wrapper">
                <div>
                    <img src="@/assets/images/logo-instrumart.gif" alt="TODO" />
                    <p class="sm-type">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque aliquet placerat.</p>
                </div>
                <div class="store-btn">Shop Now!</div>
            </a>
        </li>
        <li class="col-12 col-sm-6 col-lg-4 store-card bg-color bg-color-soft">
            <a href="#" target="_blank" class="card store-card-wrapper">
                <div>
                    <img src="@/assets/images/logo-instrumart.gif" alt="TODO" />
                    <p class="sm-type">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque aliquet placerat.</p>
                </div>
                <div class="store-btn">Shop Now!</div>
            </a>
        </li>
        <li class="col-12 col-sm-6 col-lg-4 store-card bg-color bg-color-soft">
            <a href="#" target="_blank" class="card store-card-wrapper">
                <div>
                    <img src="@/assets/images/logo-instrumart.gif" alt="TODO" />
                    <p class="sm-type">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque aliquet placerat.</p>
                </div>
                <div class="store-btn">Shop Now!</div>
            </a>
        </li>
        <li class="col-12 col-sm-6 col-lg-4 store-card bg-color bg-color-soft">
            <a href="#" target="_blank" class="card store-card-wrapper">
                <div>
                    <img src="@/assets/images/logo-instrumart.gif" alt="TODO" />
                    <p class="sm-type">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque aliquet placerat.</p>
                </div>
                <div class="store-btn">Shop Now!</div>
            </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockStoreGrid',
  props: {
    className: [String, Array],
    sectionID: String,
  },
};
</script>